module.exports = __webpack_public_path__ + "img/card_token.4bdbbc4f.png";